import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

export const MileageInformationSchema = () => {
  return z.object({
    amount: z.number({ required_error: i18n.t('expenses_v2.forms.errors.required') }),
    currency: z.string({ required_error: i18n.t('expenses_v2.forms.errors.required') }),
    mileage: z.number({ required_error: i18n.t('expenses_v2.forms.errors.required') }).gt(0, {
      message: i18n.t('expenses_v2.forms.errors.invalid_positive_number'),
    }),
    calculatedMileage: z.number().nullish(),
    units: z.string({ required_error: i18n.t('expenses_v2.forms.errors.required') }),

    rate: z
      .string()
      .nullish()
      .superRefine((value, ctx) => {
        // Checking if it's empty  or a valid numeric value to properly handle the nullish condition
        // Otherwise it will throw a non human readable error regarding the type
        if (!value || value.trim() === '') {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18n.t('expenses_v2.forms.errors.required'),
          })
          return
        }

        if (isNaN(Number(value)) || Number(value) <= 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18n.t('expenses_v2.forms.errors.invalid'),
          })
          return
        }
      }),
  })
}
